module.exports = {"DEFAULT_STATUSES_TO_SHOW":["waiting","in_transit","transferred","cancelled","ready_to_shipment"]}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/theme/transferOrderList.json
// module id = 1373
// module chunks = 1